import { lazy } from 'react';
const LocalMap = lazy(() => import('./LocalMap'));

const LocalMapRoutes = [
  {
    path: '/localmap',
    component: LocalMap
  }
];

export default LocalMapRoutes;
